import axios from "axios";
import store from "redux/store";

// utilities
import formatMoney from "./format";

// api
import api from "api/api";

/**
 * @async
 * @param {number} amount The minimum amount that satisfies the check.
 * @param {number} lang The current language.
 * @return {boolean} True if money is sufficient, false if not or if the query failed.
 */
async function checkMoney(amount, lang = "EN") {
	try {
		const { data } = await axios.get(`${api}/group/money?requiredAmount=${amount}`);

		const diff = formatMoney(Math.abs(+data.amount - amount));
		if (!data.enough && lang === "PL") {
			alert(`Nie posiadasz wystarczającej liczby pieniędzy. Brakuje ci ${diff}.`);
		} else if (!data.enough && lang != null) {
			alert(`You don't have enough money. You need ${diff} more.`);
		}

		store.dispatch({ type: "SET_MONEY", state: +data.amount });
		return data.enough;
	} catch (e) {
		console.error(e);
		alert(lang === "PL" ? "Wystąpił błąd!" : "An error occured!");
		return false;
	}
}

/**
 * @async
 * @param {string} action The action to preform: subtract or add.
 * @param {number} amount The amount to add or subtract.
 * @param {number} transactionId The transaction type id.
 * @return {Array<boolean, number|null>} [error, new amount].
 */
async function transaction(action, amount, transactionId) {
	if (isNaN(+amount)) {
		throw new TypeError(`The 'amount' argument expects a number, but received ${typeof amount}`);
	}

	if (!["add", "subtract"].includes(action)) {
		throw new TypeError(`The 'action' argument expects the string 'add' or 'subtract', but received ${action}`);
	}

	try {
		const { data } = await axios.patch(`${api}/group/money`, { action, amount, transactionId });
		store.dispatch({ type: "SET_MONEY", state: +data.amount });

		return [false, +data.amount];
	} catch (e) {
		console.error(e);
		return [true, null];
	}
}

export { checkMoney, transaction };
